<ng-container *ngIf="brand">
  <img [src]="getImageSrc()" *ngIf="brand === 'google' || brand === 'microsoft'; else brandButtons" class="brand-img" [alt]="text" />

  <ng-template #brandButtons>
    <button mat-button class="brand-button" [class]="brand" [disabled]="isDisabled">
      <app-icon [name]="brand" [isSvg]="true"></app-icon> <span>{{ text }}</span>
    </button>
  </ng-template>
</ng-container>
